export default (
  stroke = '#1043E7'
) => `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.5 0.507812C4.95995 0.635165 9.21018 2.46213 12.374 5.62598C15.6559 8.90786 17.5 13.3587 17.5 18C17.5 22.6413 15.6559 27.0921 12.374 30.374C9.21018 33.5379 4.95994 35.3639 0.5 35.4912V0.507812ZM18.5 0.507812C22.9599 0.635164 27.2102 2.46214 30.374 5.62598C33.6559 8.90786 35.5 13.3587 35.5 18C35.5 22.6413 33.6559 27.0921 30.374 30.374C27.2102 33.5379 22.9599 35.3639 18.5 35.4912V0.507812Z" fill="transparent" stroke="${stroke}"/>
</svg>
`;
